import { render } from "./Footer.vue?vue&type=template&id=373223bd&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=373223bd&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/futurefest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373223bd"]])

export default __exports__